(function(window, angular) {'use strict';

	var app = angular.module('app', [
		//'ngAnimate',
		'ui.bootstrap',
		'service',
		'ngMessages',
		'ngSocketIO',
		'ngStorage',
		'ngSanitize'
	]);

	app.config(['$httpProvider', '$localStorageProvider', function($httpProvider, $localStorageProvider) {
		$httpProvider.interceptors.push('APIInterceptorService');
		$localStorageProvider.setKeyPrefix('acplus');
	}]);

	/**
	 *
	 * Main App Controller
	 *
	 */
	app.controller('appController', ['$rootScope', '$scope', '$localStorage', function($rootScope, $scope, $localStorage) {
		/**
		 * Constructor = Init the controller
		 */
		$scope.init = function() {
			$scope.filters = $localStorage.$default({
				period:'last 3 months',
			});

			if( !$scope.filters.started_at || !$scope.filters.ended_at ) {
				$scope.setPeriodFilter();
			}
			else {
				$scope.filters.started_at = new Date($scope.filters.started_at);
		    $scope.filters.ended_at   = new Date($scope.filters.ended_at);
		  }
		}

	  /**
	   * Public MEMBERS
	   */
    $scope.resetFilters = function() {
      $localStorage.$reset({});
      $scope.setPeriodFilter($scope.filters.period);
    }

		$scope.setPeriodFilter = function(when) {
			switch( when ) {
                case 'after 30 days':
                    var date = new Date();
                    $scope.filters.started_at = new Date(date.setDate(date.getDate() + 30));
                    $scope.filters.ended_at   = new Date(date.getFullYear()+1, date.getMonth(), date.getDay());
                    break;
                case 'next 30 days':
                    var date = new Date();
                    $scope.filters.started_at = new Date(date.setDate(date.getDate() + 7));
                    $scope.filters.ended_at   = new Date(date.setDate(date.getDate() + 30));
                    break;
                case 'next 7 days':
                    var date = new Date();
                    $scope.filters.started_at = new Date();
                    $scope.filters.ended_at   = new Date(date.setDate(date.getDate() + 7));
                    break;
				case 'today':
                    var date = new Date();
                    $scope.filters.started_at = new Date();
					$scope.filters.ended_at   = new Date();
					break;

				case 'this week':
					var date = new Date();
					$scope.filters.started_at = new Date(date.setDate(date.getDate() - date.getDay() + 1));
					$scope.filters.ended_at   = new Date();
					break;

				case 'last 30 days':
					var date = new Date();
					$scope.filters.started_at = new Date(date.setDate(date.getDate() - 30));
					$scope.filters.ended_at   = new Date();
					break;

				case 'this month':
					when = 'this month';
					var date = new Date();
					$scope.filters.started_at = new Date(date.getFullYear(), date.getMonth(), 1);
					$scope.filters.ended_at   = new Date(date.getFullYear(), date.getMonth()+1, 0);
					break;

				case 'last 3 months':
					var date = new Date();
					$scope.filters.started_at = new Date();
					$scope.filters.started_at.setMonth($scope.filters.started_at.getMonth() - 3);
					$scope.filters.ended_at   = new Date();
					break;

				case 'this year':
				default:
					var date = new Date();
					$scope.filters.started_at = new Date(date.getFullYear(), 0, 1);
					$scope.filters.ended_at   = new Date();
					break;
			}

			$scope.filters.period = when;
		}

		$scope.handleError = function(error, form) {
			form.errors = [];
			if( error.status == 422 ) {
				form.show_errors = true;
	        // invalid form data
	        angular.forEach(error.data, function(errorMsg, field) {
	        	if( form && form[field] ) {
	        		form[field].$error.server = errorMsg[0];
	        		form[field].$invalid = true;
	        		form.$invalid = true;
	        	}
	        	form.errors.push(errorMsg[0]);
	        	/*else {
	        		eventService.notify('alert', {
	        			type: 'danger',
	        			message: errorMsg
	        		});
	        	}*/
	        });
	    }
	    else {
	    	/*eventService.notify('alert', {
	    		type: 'danger',
	    		message: error.status
	    	});*/
	    	form.errors.push("Erreur interne:" + error.status);
	    }
	    $scope.loading = false;
		}
	}]);

})(window, window.angular);
